var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from 'react';
import SearchInput from '../SearchInput';
import { debounce } from '../TimingUtils';
import { LoadingIndicator } from '../LoadingIndicator';
import { Article } from './Article';
import './style/articleSearch.scss';
export class ArticleSearch extends React.Component {
    constructor(props) {
        super(props);
        this._minSearchTermLength = 4;
        this.state = {
            isLoading: false,
            searchValue: '',
            hasSearched: false
        };
        this.salesForceCallback = debounce(this.salesForceCallback.bind(this), 250);
        this.onChangeSearch = this.onChangeSearch.bind(this);
    }
    componentDidUpdate(prevProps) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.props.isVisible && this.props.isVisible !== prevProps.isVisible) {
                this.setState({ isLoading: true });
                yield this.props.searchTermCallBack(this.props.initialSearchTerms);
                this.setState({ isLoading: false });
            }
        });
    }
    render() {
        return (React.createElement("div", { className: "article-search" },
            React.createElement("div", { className: "article-search__input-container" },
                React.createElement(SearchInput, { onChange: this.onChangeSearch, placeholderText: "Search Articles" })),
            React.createElement("div", { className: "suggested-articles" },
                React.createElement("div", { className: "suggested-articles__header" }, !this.state.isLoading && this.renderHeaderText()),
                this.renderListBody())));
    }
    renderListBody() {
        if (this.state.isLoading) {
            return (React.createElement("div", { className: "suggested-articles__loading" },
                React.createElement(LoadingIndicator, null),
                React.createElement("div", { className: "suggested-articles__loading-text" }, "Searching Articles...")));
        }
        if (!this.props.articles.length && !this.state.isLoading && this.state.hasSearched) {
            return (React.createElement("div", { className: "suggested-articles__no-articles" }, "Try searching again or submit a support ticket and we'll have our team take a look."));
        }
        return (React.createElement("ul", { className: "suggested-articles__articles" }, this.props.articles.map(article => {
            return this.renderArticleLink(article);
        })));
    }
    renderArticleLink(article) {
        return (React.createElement(Article, { article: article, goToArticle: this.props.goToArticle, key: `article-${article.id}` }));
    }
    renderHeaderText() {
        const { hasSearched } = this.state;
        const { articles } = this.props;
        if (!articles.length && hasSearched) {
            return 'No articles found';
        }
        else if (articles.length && hasSearched) {
            return 'Search Results';
        }
        else {
            return 'Suggested articles:';
        }
    }
    onChangeSearch(value) {
        this.setState({ searchValue: value });
        if (value.length < this._minSearchTermLength) {
            return;
        }
        this.salesForceCallback(value);
    }
    salesForceCallback(value) {
        return __awaiter(this, void 0, void 0, function* () {
            this.setState({ isLoading: true });
            yield this.props.searchTermCallBack(value);
            this.setState({ isLoading: false, hasSearched: true });
        });
    }
}
export default { ArticleSearch };
